import {
  alpha,
  Button,
  IconButton,
  Switch,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { MdContentCopy } from 'react-icons/md';
import isColorDark from '../../../../../utils/isColorDark';

export const MiddleOfThePageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '10px 0',
  '& .MuiSvgIcon-root': {
    color: theme.palette.global.white,
  },
}));

export const SearchAndFilterStyled = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '42px',
});

export const SearchStyled = styled('div')({
  display: 'flex',
  borderRadius: '5px',
  height: '35px',
  width: '536px',
  right: '10px',
  textAlign: 'center',
  border: '1px solid #cccccccc',
});

export const TextFieldStyled = styled('input')({
  width: '500px',
  border: 'none',
  borderRadius: '5px',
  padding: '0 14px',
  fontSize: '16px',
  fontFamily: 'montserrat',
  backgroundColor: '#f2f2f2',
  outline: 'none',
});

export const ButtonInputStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.global.white,
  height: '32px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.9),
  },
}));

export const FilterButtonStyled = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 60,
  width: 60,
  '& .active': {
    borderRadius: '50%',
    backgroundColor: alpha(theme.palette.secondary.main, 0.2),
  },
}));

export const LoaderContainerStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '90vw',
  height: '50vh',
  alignItems: 'center',
  gap: 16,
});

export const TableStyled = styled(TableContainer)({
  minHeight: 80,
  maxHeight: 640,
});

export const TableCellHeaderStyled = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: isColorDark(theme.palette.primary.main)
    ? theme.palette.global.white
    : theme.palette.global.black,
  fontWeight: 400,
  textAlign: 'center',
  fontSize: '12px',
  '& div': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 0.1),
  },
}));

export const TableCellBodyStyled = styled(TableCell)({
  padding: '12px',
  fontSize: '12px',
});

export const SwitchStyled = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 16,
  padding: 0,
  borderRadius: 21,
  margin: 'auto',
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 12,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(7px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: '2px',
    '&.Mui-checked': {
      transform: 'translateX(17px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? '#177ddc'
            : theme.palette.secondary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    transition: theme.transitions.create(['width'], {
      duration: 140,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,.35)'
        : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export const AttachmentStyled = styled('div')(({ theme }) => ({
  width: '25px',
  height: '25px',
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: '3px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
  color: theme.palette.primary.main,
  fontWeight: 600,
}));

export const IconContentStyled = styled(MdContentCopy)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const DivNoDataStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
});

export const TotalAmountStyled = styled('div')({
  backgroundColor: '#f2f2f2',
  display: 'flex',
  justifyContent: 'space-between',
  padding: 18,
  '& h3': {
    fontWeight: 'bold',
    fontSize: '16px',
  },
});
